import { render } from "./bg-bar.vue?vue&type=template&id=d6be8bd6&scoped=true&ts=true"
import script from "./bg-bar.vue?vue&type=script&lang=ts"
export * from "./bg-bar.vue?vue&type=script&lang=ts"

import "./bg-bar.vue?vue&type=style&index=0&id=d6be8bd6&lang=scss&scoped=true"

import exportComponent from "/Users/gkozyrev/Desktop/Projects/Ginoice/Projects/Dmitry_Voloshin-dornn/cybercola/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6be8bd6"]])

export default __exports__